module.exports = __webpack_public_path__ + "img/footer_logo.a0f7ad11.png";